jQuery(function($){ 
    
    function portfolioLoadmore(loadbtn){
        $(loadbtn).click(function(){
            //custom query on front-page.php
            var button = $(this),
                data = {
                'action': 'portfolioloadmore',
                'query': portfolio_posts_myajax,
                'page' : portfolio_filter_page_myajax
            };

            $.ajax({
                url : portfolio_ajaxurl, // AJAX handler
                data : data,
                type : 'POST',
                beforeSend : function ( xhr ) {
                    button.find('span').text('Loading...'); // change the button text, you can also add a preloader image
                },
                success : function( data ){
                    if( data ) { 
                        button.find('span').text( 'Load More' ).parent().prev().after(data); // insert new posts
                        portfolio_filter_page_myajax++;

                        if ( portfolio_filter_page_myajax == portfolio_max_page_myajax )
                            button.remove(); // if last page, remove the button
                    } else {
                        button.find('span').text( 'No data' );
                    }
                }
            });
        });	
    };
    
    portfolioLoadmore('.portfolio_loadmore');
});